import { render, staticRenderFns } from "./couponForm.vue?vue&type=template&id=47b15257"
import script from "./couponForm.vue?vue&type=script&lang=js"
export * from "./couponForm.vue?vue&type=script&lang=js"
import style0 from "./couponForm.vue?vue&type=style&index=0&id=47b15257&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports